export default "__VITE_ASSET__Bk$I7w_V__"